export default "__VITE_ASSET__BAebjxPR__"